import './index.scss'
$(".product-nav ul li").eq(0).addClass("active");
$(".product-list .container").eq(0).addClass("active");
$(".product-nav ul li").click(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".product-list .container").eq(index).addClass("active").siblings().removeClass("active");
})
$(".faq-list li").click(function() {
    $(this).find(".text").slideToggle();
    $(this).toggleClass("active");
})

if ( window.innerWidth> 1024) {
    $(window).on('scroll', function() {
        var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
        var modulePosition = $('.section2').offset().top; // 获取目标模块的顶部位置
        var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
        // 检查是否滚动到了模块的顶部或底部（根据需要选择）
        if (scrollPosition >= modulePosition - 100) { // 到达顶部（可根据需要调整距离）
            $(".product-nav ul").addClass("fixed");
        }
        else{
          $(".product-nav ul").removeClass("fixed");
            
        }

        
    });
  }